import { DownloadOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  FINANCIAL_RESULTS_REPORT,
  REVENUE_STATEMENT,
  ACTUAL_IMPLEMENTATION,
  DETAILS_OF_EXPENSES,
  EXPENSE_BY_ARTICLES_REPORT,
  SALARY_REPORT,
  TABLET,
} from '@app/constants';
import { useContentWidth, useExportToExcel } from '@app/hooks';
import { TABS_WITH_EXCEL_EXPORT } from '@app/pages/Analytics/AnalyticsLayout/data';
import { getActionItems } from '@app/pages/Analytics/AnalyticsLayout/utils';
import { getShownReportPeriod } from '@app/pages/Analytics/utils';
import { useHeader } from '@app/providers';

export const AnalyticsLayoutHeader = () => {
  const [searchParams] = useSearchParams();
  const { contentWidth } = useContentWidth();
  const [loader, setLoader] = useState(false);

  const { header } = useHeader();

  const {
    handleExportToExcelFinancialPnLReport,
    handleExportToExcelFinancialSalaryReport,
    handleExportToExcelFinancialDetailsOfExpensesReport,
    handleExportToExcelFinancialIncomesReport,
    handleExportToExcelFinancialFactImplReport,
    handleExportToExcelFinancialExpensesByArticlesReport,
    handleExportToExcelFinancialReports,
  } = useExportToExcel({ setLoader });

  const activeTab = searchParams.get('tab');

  // Экспортируем за период таблицы, показанной в активной вкладке.
  const shownPeriod = useMemo(
    () => getShownReportPeriod(header, activeTab),
    [header, activeTab]
  );

  const exportCurrentReport = useCallback(() => {
    switch (activeTab) {
      case FINANCIAL_RESULTS_REPORT:
        return handleExportToExcelFinancialPnLReport(shownPeriod);
      case REVENUE_STATEMENT:
        return handleExportToExcelFinancialIncomesReport(shownPeriod);
      case ACTUAL_IMPLEMENTATION:
        return handleExportToExcelFinancialFactImplReport(shownPeriod);
      case DETAILS_OF_EXPENSES:
        return handleExportToExcelFinancialDetailsOfExpensesReport(shownPeriod);
      case EXPENSE_BY_ARTICLES_REPORT:
        return handleExportToExcelFinancialExpensesByArticlesReport(
          shownPeriod
        );
      case SALARY_REPORT:
        return handleExportToExcelFinancialSalaryReport(shownPeriod);
      default:
        return null;
    }
  }, [
    activeTab,
    shownPeriod,
    handleExportToExcelFinancialPnLReport,
    handleExportToExcelFinancialSalaryReport,
    handleExportToExcelFinancialDetailsOfExpensesReport,
    handleExportToExcelFinancialIncomesReport,
    handleExportToExcelFinancialFactImplReport,
    handleExportToExcelFinancialExpensesByArticlesReport,
  ]);

  const exportAllReports = useCallback(
    () => handleExportToExcelFinancialReports(shownPeriod),
    [handleExportToExcelFinancialReports, shownPeriod]
  );

  const actionItems = getActionItems({
    exportCurrentReport,
    exportAllReports,
    activeTab,
  });

  if (!activeTab || !TABS_WITH_EXCEL_EXPORT.includes(activeTab)) {
    return null;
  }

  return (
    <Dropdown
      className="test-edit-client-dropdown-button"
      menu={{ items: actionItems }}
    >
      <Button icon={<DownloadOutlined />} loading={loader}>
        {contentWidth > TABLET ? 'Экспорт в Excel' : null}
      </Button>
    </Dropdown>
  );
};
